(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maple-collection-grid"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
    Maple: <maple-filter-numbers> shows Search & Discovery's decimal filter values without a trailing
    ".0" ("100.0" -> "100", "12.0" -> "12"; "51.2" and "5.12" stay). Display only: it rewrites text nodes
    that are a whole value (and an aria-label that is one) inside the filter areas of this section
    (.facets: the column from 990px, the filter drawer, the count/sort bar), never an input's value, a
    filter URL or a count. In the removable pills that print "Group: value" (the filters block's "show
    filter label" setting) only the value part changes.
    Horizon re-renders this section on every filter or sort change (Section Rendering API + morph, which
    puts the server text "100.0" back), and its facet scripts write labels into the status bubbles: the
    MutationObserver on the section wrapper runs the same pass after each such change. Mutation
    callbacks run before the browser paints (and before a view transition's new snapshot), so "100.0"
    never shows after a re-render. Without JavaScript the labels read "100.0" (Shopify's own text).
    The element is empty and hidden; it starts on connect and stops on disconnect, so a theme-editor
    re-render of the section starts a fresh observer.
  */
  if (!customElements.get('maple-filter-numbers')) {
    const WHOLE_VALUE = /^(\s*-?\d+)\.0(\s*)$/;
    const PILL_VALUE = /^(\s*\S[\s\S]*:\s+-?\d+)\.0(\s*)$/;

    const touchesFilters = (node) => {
      const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
      return !!element && (element.closest('.facets') !== null || element.querySelector('.facets') !== null);
    };

    class MapleFilterNumbers extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.root = this.closest('.shopify-section') || this.parentElement;
        if (!this.root) return;
        this.observer = new MutationObserver((records) => {
          if (records.some((record) => touchesFilters(record.target))) this.tidy();
        });
        this.tidy();
        this.observer.observe(this.root, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['aria-label'],
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        this.root = null;
      }

      /** One pass over the filter areas; idempotent. */
      tidy() {
        if (!this.root) return;
        for (const facets of this.root.querySelectorAll('.facets')) {
          const walker = document.createTreeWalker(facets, NodeFilter.SHOW_TEXT);
          for (let node = walker.nextNode(); node; node = walker.nextNode()) {
            const parent = node.parentElement;
            if (!parent || parent.closest('script, style, template, textarea')) continue;
            let text = node.data.replace(WHOLE_VALUE, '$1$2');
            if (text === node.data && parent.closest('.facets-remove__pill')) {
              text = node.data.replace(PILL_VALUE, '$1$2');
            }
            if (text !== node.data) node.data = text;
          }
          for (const element of facets.querySelectorAll('[aria-label]')) {
            const label = element.getAttribute('aria-label') || '';
            const tidied = label.replace(WHOLE_VALUE, '$1$2');
            if (tidied !== label) element.setAttribute('aria-label', tidied);
          }
        }
        // This pass's own changes need no second pass
        if (this.observer) this.observer.takeRecords();
      }
    }

    customElements.define('maple-filter-numbers', MapleFilterNumbers);
  }

  } catch(e) { console.error(e); }
})();
})();
